import React, { ReactNode, useRef, useState } from "react";

import styles from "./Accordion.module.scss";

interface Props {
  children: ReactNode;
  title: string | ReactNode;
  startOpen?: boolean;
  id?: string;
}

export const Accordion = ({ children, title, startOpen = false, id }: Props) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(startOpen);
  const shouldScroll = useRef(false);

  const toggle = () => {
    setIsOpen((prev) => !prev);
    shouldScroll.current = true;
  };

  const handleScroll = () => {
    if (wrapperRef.current && isOpen && shouldScroll.current === true) {
      wrapperRef.current.scrollIntoView({ block: "start", inline: "nearest" });
    }
  };

  const buttonId = `${id}-button`;
  const bodyId = `${id}-body`;

  return (
    <div ref={wrapperRef} className={styles.accordion} id={id}>
      <h2
        id={buttonId}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls={bodyId}
        onClick={toggle}
        className={isOpen ? "" : styles.accordionClosed}
      >
        {title}
      </h2>
      <div
        id={bodyId}
        aria-labelledby={buttonId}
        className={styles.accordion_content}
        aria-expanded={isOpen}
        onTransitionEnd={handleScroll}
      >
        {children}
      </div>
    </div>
  );
};
